import { render } from "./PlaceList.vue?vue&type=template&id=0193d34d&scoped=true"
import script from "./PlaceList.vue?vue&type=script&lang=js"
export * from "./PlaceList.vue?vue&type=script&lang=js"

import "./PlaceList.vue?vue&type=style&index=0&id=0193d34d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0193d34d"]])

export default __exports__